// src/App.js
import React, { useState, useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
// import Home from './pages/Home/Home';
// import About from './pages/About/About';
// import SoftwareDevelopment from './pages/Services/SoftwareDevelopment';
// import MobileDevelopment from './pages/Services/MobileDevelopment';
// import ECommerceDevelopment from './pages/Services/ECommerceDevelopment';
// import WebsiteDevelopment from './pages/Services/WebsiteDevelopment';
// import DigitalMarketing from './pages/Services/DigitalMarketing';
// import Branding from './pages/Services/Branding';
import ThreeDAnimation from './pages/Services/ThreeDAnimation';
import EducationalConsultancy from './pages/Services/EducationalConsultancy';
// import Expertise from './pages/Expertise/Expertise';
import Portfolio from './pages/Portfolio/Portfolio';
import { Navigate } from "react-router-dom";
// import Contact from './pages/Contact/Contact';
import './styles/global.css';
import WhatsAppFloat from './components/WhatsAppFloat';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ScrollToTop from './components/ScrollToTop';
// import Splash from './splash';
import useAnalytics from './useAnalytics';
import Blog from './pages/Blog/Blog';
import Career from './pages/Career/Career';
import BlogDetails from './components/BlogDetails';
import JobApplicants from './pages/admin/Applicants/ApplicantList'
import AdminApp from "../src/pages/admin/AdminApp";
import NotFound from '../src/components/NotFound';
import AdminLogin from"../src/pages/admin/AdminLogin";
//schema file


import SchemaFile from "../src/components/Schema"





const Home = React.lazy(() => import('./pages/Home/Home'));
const About = React.lazy(() => import('./pages/About/About'));
const SoftwareDevelopment = React.lazy(() => import('./pages/Services/SoftwareDevelopment'));
const MobileDevelopment = React.lazy(() => import('./pages/Services/MobileDevelopment'));
const ECommerceDevelopment = React.lazy(() => import('./pages/Services/ECommerceDevelopment'));
const WebsiteDevelopment = React.lazy(() => import('./pages/Services/WebsiteDevelopment'));
const DigitalMarketing = React.lazy(() => import('./pages/Services/DigitalMarketing'));
const Branding = React.lazy(() => import('./pages/Services/Branding'));

// const ThreeDAnimation = React.lazy(() => import('./pages/Services/ThreeDAnimation'));
// const EducationalConsultancy = React.lazy(() => import('./pages/Services/EducationalConsultancy'));
const Expertise = React.lazy(() => import('./pages/Expertise/Expertise'));
// const Portfolio = React.lazy(() => import('./pages/Portfolio/Portfolio'));
const Contact = React.lazy(() => import('./pages/Contact/Contact'));
// const Blog = React.lazy(() => import('./pages/Blog/Blog'));
// const CreateBlog = React.lazy(() => import('./pages/Create/CreateBlog'));
// const CreateCareer = React.lazy(() => import('./pages/Create/CreateCareer'));
// const Career = React.lazy(() => import('./pages/Career/Career'));
// const BlogDetails = React.lazy(() => import('./components/BlogDetails'));
// const JobApplicants = React.lazy(() => import('./pages/Applicants/ApplicantList'));
// const BlogVisitReport = React.lazy(() => import('./pages/BlogVisits/BlogVisitReport'));
const InnerApp = () => {
  const location = useLocation();
  useEffect(() => {
  window.scrollTo(0, 0);

  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}, [location.pathname]);
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(false);
  const [splashKey, setSplashKey] = useState(0);

  // Set initial splash state based on initial pathname (runs once on app mount/hard reload)
  // useEffect(() => {
  //   if (location.pathname === '/') {
  //     setShowSplash(true);
  //   } else {
  //     setShowSplash(false);
  //   }
  // }, []);
   // Empty dependency array: runs only once on mount

  // Function to restart splash screen
  const restartSplash = useCallback(() => {
    // Scroll to top immediately before showing splash
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
   
    // Force a reflow to ensure scroll happens
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
   
    setShowSplash(true);
    setSplashKey(prevKey => prevKey + 1);
    navigate('/', { replace: true });
  }, [navigate]);

  // Tracks pageviews inside Router safely
  const AnalyticsTracker = () => {
    useAnalytics();
    return null;
  };

  // const handleSplashComplete = useCallback(() => {
  //   setShowSplash(false);
  //   requestAnimationFrame(() => {
  //     window.scrollTo({
  //       top: 0,
  //       left: 0,
  //       behavior: 'instant'
  //     });
  //     document.documentElement.scrollTop = 0;
  //     document.body.scrollTop = 0;
  //   });
  // }, []);

  // if (showSplash) {
  //   return <Splash key={splashKey} onComplete={handleSplashComplete} />;
  // }
const isAdminRoute = location.pathname.startsWith("/admin-control-panel");
const isNotFoundRoute = location.pathname === "*";



const hideWhatsApp =
  location.pathname.startsWith("/admin-control-panel") ||
  location.pathname === "/404";




const hideLayout =
  location.pathname.startsWith("/admin-control-panel") ||
  location.pathname === "/404";
  return (
    <>
      <ScrollToTop />
      {/* ✅ Analytics hook is now inside Router */}
      
      <AnalyticsTracker />
         <SchemaFile />
      <div className="App">
{!hideLayout && <Navbar onLogoClick={restartSplash} />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/software-development" element={<SoftwareDevelopment />} />
          <Route path="/mobile-development" element={<MobileDevelopment />} />
          <Route path="/ecommerce-development" element={<ECommerceDevelopment />} />
          <Route path="/website-development" element={<WebsiteDevelopment />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/branding" element={<Branding />} />
          <Route path="/3danimations" element={<ThreeDAnimation />} />
          <Route path="/educational-consultancy" element={<EducationalConsultancy />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
            <Route path="/our-blog" element={<Blog/>} />
                        <Route path="/career" element={<Career/>} />
<Route path="/admin-control-panel/admin-login" element={<AdminLogin />} />

<Route path="/admin-control-panel/*" element={<AdminApp />} />
                        {/* <Route path="/blog" element={<Blog />} /> */}
        <Route path="/blog/:title" element={<BlogDetails />} />



<Route path="/404" element={<NotFound />} />
<Route path="*" element={<Navigate to="/404" replace />} />    
        </Routes>
   {!hideWhatsApp && <WhatsAppFloat />}
   
{!hideLayout && <Footer onLogoClick={restartSplash} />}
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <InnerApp />
    </Router>
  );
}

export default App;